import React from "react";

function Disclaimer() {
  return (
    <div className="legal-page">
      <h1>Research Use Disclaimer</h1>

      <p>
        All products offered by NovaPeptide Labs are strictly for laboratory
        research purposes only.
      </p>

      <h2>Not for Human Consumption</h2>
      <p>
        Products are not intended for human consumption, injection, medical,
        cosmetic, or veterinary use.
      </p>

      <h2>Qualified Professionals Only</h2>
      <p>
        Products must only be handled by qualified professionals trained in
        laboratory procedures and safety protocols.
      </p>

      <h2>No Medical Claims</h2>
      <p>
        NovaPeptide Labs makes no medical claims regarding the use of any
        products sold on this website.
      </p>

      <h2>Buyer Responsibility</h2>
      <p>
        The purchaser assumes full responsibility for compliance with all
        applicable laws and regulations.
      </p>
    </div>
  );
}

export default Disclaimer;
